import React from 'react'

import { F0Card } from '@factorialco/f0-react'

import { FeatureItemProps } from 'modules/marketplace_modules/components/Revamp/types'

export const FeatureItem: React.FC<FeatureItemProps> = ({ feature }) => {
  return (
    <F0Card
      avatar={{
        type: 'emoji',
        emoji: feature.emoji || '',
      }}
      title={feature.title || ''}
      description={feature.description || ''}
    />
  )
}
